export class OfferDiffService {

  static compare(originalOffer, currentOffer) {

    const changes = [];

    this.compareNode(
      "",
      originalOffer,
      currentOffer,
      changes
    );

    return changes;
  }

  static compareNode(path, oldValue, newValue, changes) {

    // identyczne
    if (oldValue === newValue)
      return;

    // null
    if (oldValue == null || newValue == null) {

      changes.push({
        type: "changed",
        path,
        oldValue,
        newValue
      });

      return;
    }

    // tablice

    if (Array.isArray(oldValue) && Array.isArray(newValue)) {

      this.compareArray(
        path,
        oldValue,
        newValue,
        changes
      );

      return;
    }

    // obiekty

    if (
      typeof oldValue === "object" &&
      typeof newValue === "object"
    ) {

      const keys = new Set([
        ...Object.keys(oldValue),
        ...Object.keys(newValue)
      ]);

      keys.forEach(key => {

        this.compareNode(
          path
            ? `${path}.${key}`
            : key,
          oldValue[key],
          newValue[key],
          changes
        );

      });

      return;
    }

    // liczba/string/bool

    changes.push({

      type: "changed",

      path,

      oldValue,

      newValue

    });

  }

  static compareArray(path, oldArray, newArray, changes) {

    const max = Math.max(
      oldArray.length,
      newArray.length
    );

    for (let i = 0; i < max; i++) {

      this.compareNode(
        `${path}[${i}]`,
        oldArray[i],
        newArray[i],
        changes
      );

    }

  }

}